import React from 'react';
import classnames from 'classnames2';
import { Illustration } from '../Illustration';
import styles from './BrandFooter.scss';
export var BrandFooter = function BrandFooter(props) {
  return React.createElement("div", {
    className: classnames(styles.footerFrame, props.className),
    "data-test": props.dataTest,
    id: props.id,
    role: "presentation"
  }, React.createElement(Illustration, {
    illustration: "opengov-logo",
    ariaLabel: "OpenGov",
    height: 16,
    width: 16,
    className: classnames(styles.footerIcon)
  }), React.createElement("div", {
    className: classnames(styles.footerText),
    "data-test": 'footer-text'
  }, props.text));
};